export default "__VITE_ASSET__DrKsxYy8__"